export const SHOPS_TABLE_ACCORDION = 'shops-table-accordion';
export const ACCOUNTS_TABLE_ACCORDION = 'accounts-table-accordion';
export const USERS_TABLE_ACCORDION = 'users-table-accordion';
export const CATALOGS_TABLE_ACCORDION = 'catalogs-table-accordion';
